import { StateUserMap } from '../../../types'
import { CURRENT_USER_SUCCESS, USERS_SUCCESS } from '../../constants'
import { IAuthJwtPayloadDTO, IStateUser } from '../../../types/user'
import { ISuccessAction } from '../common'
import { IMap } from '../../../types/common'
import { userService } from '../../../services/User'

export interface IUserAction {
  type: string
}

export interface IUsersSaveAction extends IUserAction {
  users: StateUserMap
}
export interface ICurrentUser extends IUserAction {
  userId: string
}

export function getUsersSuccess(data: IMap<IStateUser>): ISuccessAction<IMap<IStateUser>> {
  return {
    type: USERS_SUCCESS,
    data
  }
}

export function setCurrentUserToStore(accessJwtPayload: IAuthJwtPayloadDTO) {
  return {
    type: CURRENT_USER_SUCCESS,
    userId: accessJwtPayload.id
  }
}

export const fetchById = async (id: string): Promise<IStateUser> => userService.fetchUserById(id)



// WEBPACK FOOTER //
// ./src/state/actions/users/index.ts